import React from 'react';

const selectedCompanyContext = React.createContext({
    is_company_keys_user: false,
    company_keys: [],
    selected_company_key: null,
    setSelectedCompanyKey: () => {},
    companies_map: {},
});

export default selectedCompanyContext;

export const parseCompanyKeysClaim = (raw) => {
    let value = raw;
    if (typeof value === 'string') {
        try {
            value = JSON.parse(value);
        } catch (e) {
            return [];
        }
    }
    return Array.isArray(value) ? value.filter((item) => typeof item === 'string') : [];
};
